(function (aimi_mdcdot_campaign_api, $, app, undefined) {

  app.apis['mdcdot'] = app.apis['mdcdot'] || {};

  app.apis['mdcdot']['campaign'] = {
    'list': function (url, sortBy, sortByDirection, searchParams) {

      if (!app.isEmpty(sortBy)) {
        url = Utils.addParamToURL(url, {'sortField': sortBy});
      }

      if (!app.isEmpty(sortByDirection)) {
        url = Utils.addParamToURL(url, {'sortDirection': sortByDirection});
      }

      if (!app.isEmpty(searchParams)) {
        const filterHash = objectHash.sha1(searchParams);
        url = Utils.appendQueryString(url, Utils.jsonToQueryString(searchParams));
        url = Utils.appendQueryString(url, Utils.jsonToQueryString({filterHash: filterHash}));
      }

      return app.getRequest(url, {}, function () {
      }, function () {
      }, '');
    },
    refresh: function (id, searchParams) {
      let url = `/api/mdcdot/campaign/${id}/data`;

      if (!app.isEmpty(searchParams)) {
        const filterHash = objectHash.sha1(searchParams);
        url = Utils.appendQueryString(url, Utils.jsonToQueryString(searchParams));
        url = Utils.appendQueryString(url, Utils.jsonToQueryString({filterHash: filterHash}));
      }

      return app.postRequest(url, searchParams, function () {
      }, function () {
      }, '');
    },
    sequences: function (id, searchParams = {}) {
      let url = `/api/mdcdot/campaign/${id}/sequences`;
      if (!app.isEmpty(searchParams)) {
        url = Utils.appendQueryString(url, Utils.jsonToQueryString(searchParams));
      }

      return app.getRequest(url, {}, function () {
      }, function () {}, '');
    },
    searchStats: function (id, searchParams) {
      let url = `/api/mdcdot/campaign/${id}/data`;

      if (!app.isEmpty(searchParams)) {
        const filterHash = objectHash.sha1(searchParams);
        url = Utils.appendQueryString(url, Utils.jsonToQueryString(searchParams));
        url = Utils.appendQueryString(url, Utils.jsonToQueryString({filterHash: filterHash}));
      }

      return app.getRequest(url, {}, function () {
      }, function () {
      }, '');
    },

  };

  app.apis['mdcdot_campaign'] = {
    save : function (requestData) {
      return app.postRequest(`/api/mdcdot/campaign`, requestData, function () {
      }, function () {
      }, '');
    },
    update : function (requestData) {
      let url = `/api/mdcdot/campaign/${requestData.campaignId}`;
      if(!app.isEmpty(requestData.sequenceId)) {
        url += `/${requestData.sequenceId}`;
      }
      return app.putRequest(url, requestData, function () {
      }, function () {
      }, '');
    },
    delete : function (requestData) {
      let url = `/api/mdcdot/campaign/${requestData.campaignId}`;
      if(!app.isEmpty(requestData.sequenceId)) {
        url += `/${requestData.sequenceId}`;
      }
      return app.deleteRequest(url, requestData, function () {
      }, function () {
      }, '');
    },

    dotGroups: function (){
      return app.getRequest(`/api/mdcdot/dot-group`, {}, function () {
      }, function () {
      }, '');
    },
    existingDotGroups: function (campaignId){
      return app.getRequest(`/api/mdcdot/dot-group/${campaignId}`, {}, function () {
      }, function () {
      }, '');
    },
    saveDotGroup : function (requestData) {
      return app.postRequest(`/api/mdcdot/dot-group`, requestData, function () {
      }, function () {
      }, '');
    },
    emailVariantsAimiCampaigns : function () {
      return app.getRequest(`/api/mdcdot/email-variants-aimi-campaigns`, {}, function () {
      }, function () {
      }, '');
    }
  }

  app.apis['dot_instance_campaign'] = {
    launch : function (campaignId, requestData = {}) {
      let url = `/api/admin/campaign/${campaignId}/active`;
      return app.putRequest(url, requestData, function () {
      }, function () {
      }, dotBaseUrl);
    },
    pause : function (campaignId, requestData = {}) {
      let url = `/api/admin/campaign/${campaignId}/paused`;
      return app.putRequest(url, requestData, function () {
      }, function () {
      }, dotBaseUrl);
    },

  }

  app.apis['dot_instance_apis'] = {
    lead : {
      add : function (requestData = {}) {
        let url = `/api/public/user/lead`;
        requestData = Utils.jsonToFormData(requestData);
        return app.postRequest(url, requestData, function () {
        }, function () {
        }, dotBaseUrl, false);
      },
    }

  }

  app.apis['mdcdot_sequence'] = {
    save : function (requestData) {
      return app.putRequest(`/api/mdcdot/sequence/${requestData.id}`, requestData, function () {
      }, function () {
      }, '');
    },
    leadActivityTree: function (leadId, sequenceId, action) {
      let url = `/api/mdcdot/lead/${leadId}/campaign-tree`;
      url = Utils.addParamToURL(url, {'query': action});
      if(!app.isEmpty(sequenceId)) {
        url = Utils.addParamToURL(url, {'sequenceId': sequenceId});
      }
      return app.getRequest(url , {}, function () {
      }, function () {
      }, '');
    },
    updateDotActionQueueExecutionToPastForTesting(leadId, sequenceId) {
      let url = `/api/mdcdot/lead/${leadId}/dot-action-queue/${sequenceId}`;
      return app.getRequest(url , {}, function () {
      }, function () {
      }, '');
    }
  }

  app.apis['mdcdot_email'] = {
    list: function () {
      return app.getRequest(`/api/mdcdot/email`, {},function () {
      }, function () {
      }, '');
    },
    save : function (requestData) {
      if(!app.isEmpty(requestData.id)) {
        return this.update(requestData);
      } else {
        return this.create(requestData);
      }
    },
    create : function (requestData) {
      return app.postRequest(`/api/mdcdot/email`, requestData, function () {
      }, function () {
      }, '');
    },
    update : function (requestData) {
      return app.putRequest(`/api/mdcdot/email/${requestData.id}`, requestData, function () {
      }, function () {
      }, '');
    }
  }


  app.apis['mdcdot_email_variants'] = function () {
    return {
      'list': function () {
        return app.getRequest(`/api/email/campaign`, {}, function () {
        }, function () {
        });
      },
      'get': function (id) {
        return app.getRequest(`/api/email/campaign/${id}`, {}, function () {
        }, function (response) {
          app.notify('error', response);
        }, ''); //
      },
      'delete': function (id) {
        return app.deleteRequest(`/api/email/campaign/${id}`, {}, function () {
        }, function (response) {
          app.notify('error', response);
        });
      },
      'getCampaignByCategory': function (categoryId) {
        return app.getRequest(`/api/campaign/campaign/by-category/${categoryId}`, {}, function () {
        }, function () {
        });
      },
      'imageCollections': function (id) {
        return app.getRequest(`/api/image/collection/by-app-campaign/${id}`, {}, function () {
        }, function () {
        });
      },
      'add': function (requestData) {
        return app.postRequest(`/api/email/campaign`, requestData, function () {
        }, function () {
        });
      },

      'update': function (id, requestData) {
        return app.putRequest(`/api/email/campaign/${id}`, requestData, function () {
        }, function () {
        });
      },

      'save': async function (requestData) {
        if (app.isEmpty(requestData.id)) {
          return this.add(requestData)
        } else {
          return this.update(requestData.id, requestData)
        }
      },

      'reset': function (id, requestData) {
        return app.putRequest(`/api/email/campaign/reset/${id}`, requestData, function () {
        }, function () {
        });
      },
      'categories': function (businessProfileId) {
        let url = `/api/category/${businessProfileId}`;
        url = Utils.appendQueryString(url, Utils.jsonToQueryString({channel : 'email'}));
        return app.getRequest(url, {}, function () {
        }, function () {
        });
      },
      build: function (campaignId, partial = false, keepScheduled = false) {
        let url  = `/api/email/build/`;
        url = `${url}${campaignId}?partial=${partial}&keepScheduled=${keepScheduled}`;
        return app.getRequest(url, {}, function () {
        }, function () {
        }, '');
      }
    }
  }();

}(window.aimi_mdcdot_campaign_api = window.aimi_mdcdot_campaign_api || {}, jQuery, PreBuilt));
